const FEVER_THRESHOLD_CHILD_INCLUSIVE = 37.5;
const FEVER_THRESHOLD_NON_CHILD_INCLUSIVE = 38;
const HYPOTHERMIA_THRESHOLD_EXCLUSIVE = 35.5;

const DAYS_PER_MONTH = 30.417;
const DAYS_PER_YEAR = 365;
const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;
const CENTIMETERS_PER_METER = 100;

const CHILD_AGE_MINIMUM_DAYS = 2 * DAYS_PER_MONTH;
const CHILD_AGE_MAXIMUM_DAYS = 5 * DAYS_PER_YEAR - 1;
const WEIGHT_FOR_LENGTH_MAX_AGE_DAYS = 2 * DAYS_PER_YEAR;

const WEIGHT_TABLE_LIMIT = 240;
const HR_RR_TABLE_LIMIT = 216;

const STRINGS = {
  BABY_AGE: 'baby_age',
  BODY_MASS_INDEX: 'body_mass_index',
  CALCULATED: 'calculated',
  COOL_OR_TEMP_LOW: 'cool_or_temperature_low',
  FEVER_OR_TEMP_HIGH: 'fever_or_temperature_high',
  HEART_RATE: 'heart_rate',
  HEIGHT_AGE_ZSCORE: 'height_for_age_z_score',
  HR_PERCENTILE: 'heart_rate_percentile',
  LOW_WEIGHT_RISK: 'low_weight_risk',
  MULTIPLE: 'multiple',
  NAME_SEPARATOR: '.',
  NO: 'no',
  PREGNANCY_DAYS: 'pregnancy_days',
  RESPIRATORY_RATE: 'respiratory_rate',
  RR_PERCENTILE: 'respiratory_rate_percentile',
  RESPONSE: 'response',
  TUPLE: 'tuple',
  UNKNOWN: 'unknown',
  VALUE: 'value',
  WEIGHT: 'weight',
  WEIGHT_AGE_ZSCORE: 'weight_for_age_z_score',
  WEIGHT_HEIGHT_ZSCORE: 'weight_for_height_z_score',
  WEIGHT_PERCENTILE: 'weight_percentile',
  YES: 'yes',
};

module.exports = {
  STRINGS,
  CENTIMETERS_PER_METER,
  FEVER_THRESHOLD_CHILD_INCLUSIVE,
  FEVER_THRESHOLD_NON_CHILD_INCLUSIVE,
  HYPOTHERMIA_THRESHOLD_EXCLUSIVE,
  DAYS_PER_MONTH,
  DAYS_PER_YEAR,
  MILLISECONDS_PER_DAY,
  CHILD_AGE_MINIMUM_DAYS,
  CHILD_AGE_MAXIMUM_DAYS,
  WEIGHT_FOR_LENGTH_MAX_AGE_DAYS,
  WEIGHT_TABLE_LIMIT,
  HR_RR_TABLE_LIMIT,
};
